import { RadioField, RadioInput } from '@flos/react-ui';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { useRecoilState, useRecoilValue } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import type { CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import { getCoverableIndex } from '../../../../utils/coverablesUtil';
import { useState } from 'react';
import { track } from '../../../../utils/trackingUtil';
import { useHippoText } from '../../../../hooks/useHippoText';

const DogGenderStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const [coverables, setCoverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const getHippoText = useHippoText();

    const { dogs = [] } = coverables;
    const coverableIndex = getCoverableIndex(dogs, currentProduct.fixedId);
    const coverable = dogs[coverableIndex];
    const { gender = '', name = '' } = coverable;
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleDogGenderChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = event.target;

        const updatedCoverables = [...dogs];

        updatedCoverables[coverableIndex] = {
            ...updatedCoverables[coverableIndex],
            gender: value
        };

        setCoverables((prev) => ({
            ...prev,
            dogs: updatedCoverables
        }));
    };

    const onNext = (): void => {
        setIsLoading(true);
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            dog: {
                publicId: coverable.publicId,
                fixedId: coverable.fixedId,
                gender: coverable.gender
            },
            productToUpdate: currentProduct.flavourName
        };

        void saveCoverableInformation(updatedCoverable).then(() => {
            setIsLoading(false);
            track(`${coverable.flavourName}CoverableInformationGenderOfDog`, [
                { gender: coverable.gender }
            ]);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            onPrevious={goPrevious}
            disableNext={!gender || isLoading}
            isNextLoading={isLoading}
            disablePrevious={isLoading}
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-PET-COVERABLE-INFORMATION-GENDER-QUESTION', {
                    petname: name ?? ''
                })}
            >
                <RadioField
                    value={gender}
                    onChange={handleDogGenderChange}
                    required
                    disabled={isLoading}
                >
                    <RadioInput value="Female" label="Hun" />
                    <RadioInput value="Male" label="Han" />
                </RadioField>
            </CoverableDetailsTemplate>
        </WizardPagetemplate>
    );
};

export default DogGenderStep;
